// extracted by mini-css-extract-plugin
module.exports = {"product-disclaimer__container":"_product_disclaimer_product-disclaimer__container__5W_bK"};